import React from 'react';
import './styles.scss';
import { Link } from 'react-router-dom'

export default ({link, text}) => (
  <li className="NavbarItem">
    <Link to={link}>{text}</Link>
  </li>
);
